module.exports = "/_next/static/images/e5df0233e283acff384ba7856157688c-hero-variant-a-mobile.jpg";